import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { sessionOrNone } from '../auth/me.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { entryRoute } from './entry.tsx'
import { parseToken } from './iscrizione.tsx'

// The link for the tutore, a sheet of the entrance. No guard: whoever holds the link may have no
// account. `here` is the child's «È qui con me»: the session on that phone is theirs, so it is not read.

export interface GuardianLinkSearch {
  readonly token: string
  readonly here?: true
}

export const guardianLinkRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.guardianLink,
  validateSearch: (search: Record<string, unknown>): GuardianLinkSearch => ({
    token: parseToken(search.token),
    // Left out when absent, so the link everybody else holds stays `?token=` and nothing else.
    ...(search.here === true || search.here === 'true' ? { here: true as const } : {}),
  }),
  beforeLoad: async ({ context, search }) => ({
    session: search.here === true ? null : await sessionOrNone(context.queryClient),
  }),
  component: lazyRouteComponent(() => import('../pages/guardian-link.tsx')),
})

/** The way back to this page from the login, for an account that asks for a second step. */
export function guardianPageHref(token: string): string {
  return `${NAV_PATHS.guardianLink}?token=${encodeURIComponent(token)}`
}

/** The page as a link target. `here`: the child opens it on their own phone, where the session is
 *  theirs and is not read. */
export function guardianPageLink(token: string, options: { readonly here?: boolean } = {}) {
  const here = options.here === true ? { here: true as const } : {}
  return { to: NAV_PATHS.guardianLink, search: { token, ...here } } as const
}
